import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const PDFViewer = ({ pdfUrl }) => {
  return (
    <Paper elevation={0} sx={{ p: 0, boxShadow: 'none' }}>
      {/* <Typography variant="h6" gutterBottom>
        PDF Document
      </Typography> */}
      <Box
        sx={{
          width: '100%',
          height: '600px',
          overflow: 'hidden',
        }}
      >
        <iframe
          src={`${pdfUrl}#toolbar=0`}
          width="100%"
          height="100%"
          title="PDF Viewer"
          style={{ border: 'none', display: 'block', width: '100%' }}
        />
      </Box>
    </Paper>
  );
};

export default PDFViewer; 